function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M233.9 117.2l-49.6 39.4v77.3h35.5v13.3c0 4.5-3.9 8.2-8.7 8.2H76.7c-7.2 0-13.1-5.6-13.1-12.5v-37.3H163V28.4h-49.6V0H85v28.3H56.7v70.9H0v106.3h35.5v37.3c0 22.4 18.5 40.6 41.2 40.6h134.4c20.3 0 36.8-16.3 36.8-36.3v-13.3h35.5v-77.3l-49.5-39.3zM85 56.7h49.6v120.5h-28.3v-78H85V56.7zM28.4 177.2v-49.6H78v49.6H28.4zm226.7 28.3h-42.5v-35.3l21.2-16.9 21.2 16.9v35.3h.1z"
})));